export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_PROFILE_START = "UPDATE_PROFILE_START";
export const UPDATE_PROFILE_FAILED = "UPDATE_PROFILE_FAILED";

export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const UPDATE_PASSWORD_START = "UPDATE_PASSWORD_START";
export const UPDATE_PASSWORD_FAILED = "UPDATE_PASSWORD_FAILED";
